import { createApp } from 'vue'
import StafetDeltagPaaHoldStepOne from './StafetDeltagPaaHoldStepOne'

const el = '.kb-component--stafet-join-a-team-step-one'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((StafetDeltagPaaHoldStepOneDOM) => {
            const component = createApp(StafetDeltagPaaHoldStepOne).use(Store)
            component.mount(StafetDeltagPaaHoldStepOneDOM)
        })
    }
}
